const eventTypes = [
  { id: 1, value: 'Account Audit' },
  { id: 2, value: 'Environmental meeting' },
  { id: 3, value: 'Evacuation drill' },
  { id: 4, value: 'HS Management task' },
  { id: 5, value: 'Hazard controls' },
  { id: 6, value: 'Noise assessment' },
  { id: 7, value: 'Safety inspection' },
  { id: 8, value: 'Safety meeting' },
  { id: 9, value: 'System audit' },
  { id: 10, value: 'System audit follow up' },
  { id: 11, value: 'Wardens debrief' },
  { id: 12, value: 'Wardens self test' }
];

export default { eventTypes };
